import { Divider, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { Edit, Delete, PageviewOutlined } from '@mui/icons-material';

import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/system';
import TableGridWithFilters from '../../components/TablegridWithFilters/TableGridWithFilters/TableGridWithFilters';
import Theme from '../../Themes/main.theme';
import moment from 'moment';
import { RequestDict, RequestStatus } from '../../components/dictionaries/RequestStatus';
import UserService from '../../services/UserService';
import { Permissions } from '../../lib/permissions';
import MultiStatusSelector from '../../components/EnableComponent/MultiStatusSelector';
import { useTranslation } from 'react-i18next';
import React from 'react';
import DialogAction from '../../components/Dialog/DialogAction';
import HttpService from '../../services/HttpService';
import { useSnackbar } from 'notistack';

const MyInternalRequests = () =>{
  const [open, setOpen] = React.useState(false);
  const [refetch, setRefetch] = React.useState(false);
  const [application, setApplication] = React.useState<{id: number, category: string}>();

  const navigate = useNavigate();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  document.title = t('Τα εσωτερικά μου Αιτήματα προς Καταχώριση');

  const deleteApplication = async () => {
    try {
      const application_category = application?.category === 'professionals'
        ? 'professionals'
        : application?.category === 'location' 
          && 'locations';

      await HttpService.getAxiosClient().delete(`${process.env.REACT_APP_BACKEND_URL}/applications/${application_category}/${application?.id}`);
      enqueueSnackbar('Το αίτημα διαγράφηκε επιτυχώς', { variant: 'success' });
      setRefetch((refetch) => !refetch);
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Υπήρξε πρόβλημα κατά την διαγραφή του αιτήματος, προσπαθήστε πάλι αργότερα', { variant: 'error' });
    }
  };

  const columns: GridColDef[] = [
    {
      field: 'title',
      headerName: 'Τίτλος',
      minWidth: 420,
      sortable: true
    },
    {
      field: 'submit_date',
      headerName: 'Ημερομηνία Υποβολής',
      minWidth: 340,
      sortable: true,
      renderCell: ({row}) => row.submit_date
        ? moment(row.submit_date).format('DD/MM/YYYY, HH:mm:ss').toLocaleString()
        : null
    },
    {
      field: 'status',
      headerName: 'Κατάσταση',
      minWidth: 305,
      sortable: true,
      renderCell: ({row}) => <>
        <MultiStatusSelector status={RequestDict[row.status]} 
          labelStatus={RequestDict[row.status]}/> 
      </>
    },
    {
      field: 'info',
      headerName: 'Ενέργειες',
      minWidth: 127,
      sortable: false,
      renderCell: ({row}) => 
        <>
          <Tooltip PopperProps={{
            disablePortal: true
          }}
          title='Προβολή'>
            <IconButton
              disabled={
                !UserService.hasRole([
                  Permissions.PermissionInternalLocationApplicationCreateMy_org
                ])
              }
              color='primary'
              onClick={() => 
                navigate(row.category === 'professionals'
                  ? `/admin/professionals/view/${row.id}`
                  : row.category === 'location'
                    ? `/admin/applications/view/${row.id}`
                    : `/admin/applications/details/${row.id}`)
              }>
              <PageviewOutlined />
            </IconButton>
          </Tooltip>
          <Tooltip PopperProps={{
            disablePortal: true
          }} title={'Επεξεργασία Αιτήματος'}>
            <IconButton
              color='primary'
              onClick={() => navigate(row.category === 'professionals'
                ? `/admin/professionals/edit/${row.id}`
                :`/admin/locations/edit/${row.id}`)}
              disabled={(row.status === RequestStatus.Successful) ||
              (row.status === RequestStatus.Rejected) || 
              (row.status === RequestStatus.In_Progress)}>
              <Edit/>
            </IconButton>
          </Tooltip>
          <Tooltip 
            PopperProps={{
              disablePortal: true
            }}
            title={'Διαγραφή Αιτήματος'}>
            <IconButton
              color='error'
              onClick={() => {
                setApplication({id: row.id, category: row.category});
                setOpen(true);
              }}
              disabled={row.status !== RequestStatus.Draft}>
              <Delete/>
            </IconButton>
          </Tooltip>
        </>
    }];
      
  return (
    <>
      <Typography sx={{ my: 2, mt: 4 }} variant='h2'
        color={Theme?.labelColor?.main}> {t('Τα εσωτερικά μου Αιτήματα προς Καταχώριση')}</Typography>
      <Divider sx={{mb: 5, border: 1, color: Theme?.dividerColor?.main}}/>
      <Box mt={5} minWidth={350}>
        <Paper variant='outlined' 
          sx={{ height: 'fit-content', borderRadius: 2, boxShadow: 0, backgroundColor: 'transparent'}}>
          <Typography m={2} variant='h3'> {t('Τα Αιτήματα μου')}</Typography>
          <Box m={1} >
            <TableGridWithFilters
              responseDataFieldName='data'
              responseTotalCountFieldName = 'total_count'
              rowsPerPageOptions={[15,30,50]}
              pageSize={15}
              paginationMode='server'
              sortModel={[{field: 'submit_date', sort: 'desc'}]}
              hideFilters
              columns={columns}
              reFetch={refetch}
              fetchUrl={`${process.env.REACT_APP_BACKEND_URL}/applications/locations/applicant`}
            />        
          </Box> 
        </Paper>    
      </Box>
      <DialogAction
        mode='delete'
        open={open}
        onAccept={() => {
          deleteApplication();
          setOpen(false);
        }}
        handleClose={()=> setOpen(false)}
        content='Είστε σίγουρος ότι θέλετε να διαγράψετε το συγκεκριμένο αίτημα;' 
      />
    </>
  );
};

export default MyInternalRequests;